import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';
type Props = {
  children;
};

const PrintWrapper: FunctionComponent<Props> = ({ children }) => {
  return (
    <div id="subaru-container" className={`SC SC__root-container ${styles.root}`}>
      {children}
    </div>
  );
};

export default PrintWrapper;
